import { Box, Typography } from '@mui/material';
import moment from 'moment';
import * as React from 'react';
import { ModelHistoryLog, ModelHistoryLogTypeEnum } from '../../@shared/Models/Models';
import { FlexBoxInline } from '../../@shared/templates';
import { Palette, Sizes } from '../../@shared/palette';


export type TabsContentLogsBaseProps = {
  modelHistoryLogs: ModelHistoryLog[],
}

type TabsContentLogsProps = TabsContentLogsBaseProps & {
  isVisible: boolean
}

const TabsContentLogs = (props: TabsContentLogsProps) => {
  const boxRef = React.useRef<HTMLDivElement>(null);
  const getColor = React.useCallback((type: ModelHistoryLogTypeEnum) => {
    switch (type) {
      case ModelHistoryLogTypeEnum.Error:
        return Palette.textColorError;
      case ModelHistoryLogTypeEnum.Warning:
        return Palette.textColorWarning;
      case ModelHistoryLogTypeEnum.Info:
        return Palette.textColorPrimary;
    }
  }, []);

  const orderedLogs = React.useMemo(() => [...props?.modelHistoryLogs].sort((x, y) => new Date(x.createdDate).getTime() - new Date(y.createdDate).getTime()), [props?.modelHistoryLogs])

  React.useEffect(() => {
    if (boxRef.current) {
      boxRef.current.scrollTop = boxRef.current.scrollHeight;
    }
  }, [orderedLogs])


  return <div hidden={!props.isVisible}>
    <Box ref={boxRef} sx={{ overflow: "scroll", height: "calc(100vh - 345px)" }}>
      {orderedLogs.map((x, i) => {
        const skipTime = i !== 0 && moment(x.createdDate).diff(orderedLogs[i - 1].createdDate, "minute") < 1;
        return <Box key={i} sx={{ ...FlexBoxInline, alignItems: "flex-start" }}>
          <Box sx={{ width: "150px" }}>
            {!skipTime && <Typography sx={{ fontSize: Sizes.textSecondary, color: Palette.textColorSecondary, marginTop: "3px" }}>{moment(x.createdDate).format("DD-MM-YYYY hh:mm:ss")}</Typography>}
          </Box>
          <Box sx={{ width: "90%" }}>
            <Typography sx={{ marginBottom: "5px", fontSize: Sizes.textPrimary, color: getColor(x.typeId) }}>{x.log}</Typography>
          </Box>
        </Box>
      })}
    </Box>

  </div>
}

export default TabsContentLogs;
